import { Bank } from 'models/Bank';
import { AutoCompleteInputOption } from 'components/AutoCompleteInput/AutoCompleteInput';

export const getAutoCompleteBanksOptions = (banks: Bank[]): AutoCompleteInputOption[] =>
  banks.map(({ short_name, bic, sort_code }, index) => ({
    label: short_name,
    subLabel: `(${bic} - ${sort_code})`,
    value: sort_code,
    index
  }));
